import React, { ReactNode } from 'react';

import {
  radioBoxStyles,
  radioGroupStyles,
  radioLabelStyles
} from '@/components/common/RadioGroup/styles.ts';

interface IRadioGroup {
  data: { label: string; value: string; icon?: ReactNode }[];
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  selected: string;
}

const RadioGroup = ({ data, handleChange, selected }: IRadioGroup) => (
  <div style={radioGroupStyles}>
    {data.map((el) => (
      <label key={el.value} style={radioLabelStyles(el.value === selected)}>
        <input
          type="radio"
          value={el.value}
          checked={el.value === selected}
          onChange={handleChange}
          style={{ display: 'none' }}
        />
        <p style={radioBoxStyles}>
          {el.icon && (
            <span style={{ display: 'flex', marginRight: 10 }}>{el.icon}</span>
          )}
          {el.label}
        </p>
      </label>
    ))}
  </div>
);

export default RadioGroup;
